// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"8ad01cc3","872":"228edf45"}[chunkId] + ".chunk.js";
};